import { createApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app.routes';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CDN_URL } from '@maximizer/core/shared/domain';
import { environment } from './environments/environment';
import { DEFAULT_LANGUAGE, LANGUAGE, getLanguageFromUrl } from './app/language';
import { catchError, EMPTY } from 'rxjs';

declare const LOAD_UID: string;

function initializeShowcaseLanguage() {
  const translate = inject(TranslateService);
  const language = inject(LANGUAGE);
  return translate.use(language).pipe(
    catchError((err) => {
      if (typeof ngDevMode === 'undefined' || ngDevMode) {
        console.warn(
          `[Showcase] Translation for "${language}" failed, falling back to "${DEFAULT_LANGUAGE}"`,
          err,
        );
      }
      const url = new URL(window.location.href);
      if (url.searchParams.has('language')) {
        url.searchParams.delete('language');
        window.location.href = url.toString();
        return EMPTY;
      }
      return translate.use(DEFAULT_LANGUAGE);
    }),
  );
}

createApplication({
  providers: [
    provideZoneChangeDetection(),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './i18n/',
        suffix: `.json?uid=${LOAD_UID}`,
        useHttpBackend: true,
        enforceLoading: false,
      }),
      fallbackLang: DEFAULT_LANGUAGE,
    }),
    { provide: LANGUAGE, useFactory: getLanguageFromUrl },
    { provide: CDN_URL, useValue: environment.cdn },
    provideAppInitializer(initializeShowcaseLanguage),
  ],
})
  .then((app) => app.bootstrap(AppComponent))
  .catch((err) => console.error(err));
